const AnalyticsIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.12497 3.125H16.875M3.12497 3.125V12.7083C3.12497 13.6288 3.87117 14.375 4.79164 14.375H15.2083C16.1288 14.375 16.875 13.6288 16.875 12.7083V3.125M3.12497 3.125H19.1666H16.875M3.12497 3.125H0.833313M11.6666 16.875L10.2781 14.7922M8.33331 16.875L9.72184 14.7922M9.99997 6.45833V11.0417M6.87497 9.79167V11.0417M13.125 8.125V11.0417"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default AnalyticsIcon
